import type { PositionBudget } from '../../../../types/scholarships';

/**
 * "Need: 2 • First emphasis" under a position card's heading, from the position needs set in
 * Configure roster. Nothing when the coach stated neither a count nor a note for the position.
 */
export const NeedLine = ({ need }: { need?: PositionBudget }) => {
  if (!need) return null;
  const note = need.note?.trim() ?? '';
  if (need.playersNeeded == null && note.length === 0) return null;
  return (
    <p className="depth-chart-card__need">
      Need: {need.playersNeeded ?? '—'}
      {note.length > 0 && (
        <>
          <span aria-hidden="true"> • </span>
          <span className="roster-sr-only">, </span>
          {note}
        </>
      )}
    </p>
  );
};
